module.exports = __webpack_public_path__ + "img/18.93e012e0.jpg";